import { connect } from 'react-redux'
import Modal from 'components/modal/modal'
import { ModalBody } from 'react-bootstrap'
import { QRCode } from 'react-qr-svg'
import { Input } from 'components/forms'
import { LinkButton } from 'components/buttons'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { successMessage } from 'lib/flash-message'
import { createTwoFactorProvision, createTwoFactor } from '../../api'
import { getTwoFactors } from '../../actions'

export interface ConfigureTwoFactorAuthModalProps {
  getTwoFactors: () => void
  onHide: () => void
  show: boolean
}

export const BaseConfigureTwoFactorAuthModal = ({
  getTwoFactors,
  onHide,
  show,
}: ConfigureTwoFactorAuthModalProps) => {
  const { data } = useQuery({
    queryKey: ['createTwoFactorProvision'],
    queryFn: createTwoFactorProvision,
    enabled: show,
    refetchOnWindowFocus: false,
  })
  const provisioningUri = data?.provisioningUri
  const secret = data?.otpSecret
  const { register, handleSubmit, errors, setError } = useForm()

  const onSubmit = (otp: any) => {
    createTwoFactor(otp)
      .then(() => {
        onHide()
        successMessage('Two-factor authentication enabled.')
        getTwoFactors()
      })
      .catch((res) => {
        setError('otpAttempt', 'error', res.error.message)
      })
  }

  return (
    <Modal
      show={show}
      title="Configure Two-Factor Authentication"
      onHide={onHide}
    >
      <ModalBody>
        <ol>
          <li>
            <strong>Open</strong> your Authenticator App. (1Password, Google
            Authenticator, etc.)
          </li>
          <li>
            <strong>Scan</strong> the QR code below. <br />
            {provisioningUri && (
              <QRCode className="pam" value={provisioningUri} width={200} />
            )}
          </li>
          <li>
            <strong>Enter One-Time-Password</strong> generated by the app.
            <form onSubmit={handleSubmit(onSubmit)}>
              <Input
                ariaHidden
                inputRef={register}
                label="Secret"
                name="otpSecret"
                type="hidden"
                value={secret}
              />
              <Input
                addonAfter={
                  <LinkButton
                    className="text-bold text-brand-info man pan"
                    type="submit"
                  >
                    Verify
                  </LinkButton>
                }
                id="otpAttempt"
                label="Enter One-Time-Password"
                ariaLabel="Enter One-Time-Password"
                error={errors.otpAttempt?.message}
                groupClassName="mtm"
                groupStyle={{ width: 200 }}
                inputRef={register}
                name="otpAttempt"
              />
            </form>
          </li>
        </ol>
      </ModalBody>
    </Modal>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  getTwoFactors: () => dispatch(getTwoFactors()),
})

export const ConfigureTwoFactorAuthModal = connect(
  null,
  mapDispatchToProps
)(BaseConfigureTwoFactorAuthModal)
